<template>
    <div class="contact">
        <div class="banner">
                <el-carousel height="330px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img  v-if="languageType == 0" @click="toProductdetail(item.category,item.productName)" :src="item.picUrl"/>
                        <img v-else @click="toProductdetail(item.category,item.productName)" :src="item.enPicUrl"/>
                    </el-carousel-item>
                </el-carousel>
        </div>
        <div class="head_title">
            <ul>
                <li>
                    <p>联系我们</p>
                    <span>Contact us</span>
                </li>
            </ul>
            <div class="local">
                <p v-if="languageType == 0">当前位置：首页 > 联系我们</p>
                <p v-else>Location: Home > Download Center</p>
            </div>
        </div>
        <div class="content">
            <div class="intro">
                <div class="top">
                    <div class="text">
                        <div class="title">
                            <p>联系我们</p>
                            <span>Contact us</span>
                        </div>
                        <p>{{languageType == 0?'电话':'Phone'}}：{{languageType == 0?'+86-20-23885033':'0085256031419'}}</p>
                        <p>E-mail：{{languageType == 0?'contact@arccer.com':'admin@arccer.com'}}</p>
                        <p>{{languageType == 0?'地址：广州市番禺区星力动漫产业园A2-A6':'Address：A2-A6, Xingli Animation Industrial Park, Panyu District, Guangzhou'}}</p>
                        <p v-if="languageType != 0">WhatsApp：00852-56031419</p>
                    </div>
                    <div class="ewm">
                        <img src="../../static/img/gzh.png"/>
                        <p>{{languageType == 0?'售后服务专属微信公众号':'After-sales WeChat public account'}}</p>
                    </div>
                </div>
                <div class="bottom">
                    <div class="map" id="dituContent"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props:['languageType'],
    data () {
        return {
            bannerList:[],
        }
    },
    created () {
        this.$emit('changeIndex',3)
        this.getBannerList()
        
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getBannerList()
            }
        }

    },
    mounted () {
        this.creatinitMap();//创建和初始化地图
    },
    methods:{
        creatinitMap () {

                //创建和初始化地图函数：
                function initMap(){
                    createMap();//创建地图
                    setMapEvent();//设置地图事件
                    addMapControl();//向地图添加控件
                    addMarker();//向地图中添加marker
                }
                
                //创建地图函数：
                function createMap(){
                    var map = new BMap.Map("dituContent");//在百度地图容器中创建一个地图
                    var point = new BMap.Point(113.38338,22.975947);//定义一个中心点坐标
                    map.centerAndZoom(point,17);//设定地图的中心点和坐标并将地图显示在地图容器中
                    window.map = map;//将map变量存储在全局
                }
                
                //地图事件设置函数：
                function setMapEvent(){
                    map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
                    map.enableScrollWheelZoom();//启用地图滚轮放大缩小
                    map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
                    map.enableKeyboard();//启用键盘上下左右键移动地图
                }
                
                //地图控件添加函数：
                function addMapControl(){
                    //向地图中添加缩放控件
                var ctrl_nav = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_RIGHT,type:BMAP_NAVIGATION_CONTROL_LARGE});
                map.addControl(ctrl_nav);
                    //向地图中添加缩略图控件
                var ctrl_ove = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:0});
                map.addControl(ctrl_ove);
                    //向地图中添加比例尺控件
                var ctrl_sca = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
                map.addControl(ctrl_sca);
                }
                
                //标注点数组
                var markerArr = [{title:"胜骅科技",content:"胜骅动漫科技有限公司",point:"113.38294|22.976014",isOpen:0,icon:{w:21,h:21,l:0,t:0,x:6,lb:5}}
                    ];
                //创建marker
                function addMarker(){
                    for(var i=0;i<markerArr.length;i++){
                        var json = markerArr[i];
                        var p0 = json.point.split("|")[0];
                        var p1 = json.point.split("|")[1];
                        var point = new BMap.Point(p0,p1);
                        var iconImg = createIcon(json.icon);
                        var marker = new BMap.Marker(point,{icon:iconImg});
                        var iw = createInfoWindow(i);
                        var label = new BMap.Label(json.title,{"offset":new BMap.Size(json.icon.lb-json.icon.x+10,-20)});
                        marker.setLabel(label);
                        map.addOverlay(marker);
                        label.setStyle({
                                    borderColor:"#808080",
                                    color:"#333",
                                    cursor:"pointer"
                        });
                        
                        (function(){
                            var index = i;
                            var _iw = createInfoWindow(i);
                            var _marker = marker;
                            _marker.addEventListener("click",function(){
                                this.openInfoWindow(_iw);
                            });
                            _iw.addEventListener("open",function(){
                                _marker.getLabel().hide();
                            })
                            _iw.addEventListener("close",function(){
                                _marker.getLabel().show();
                            })
                            label.addEventListener("click",function(){
                                _marker.openInfoWindow(_iw);
                            })
                            if(!!json.isOpen){
                                label.hide();
                                _marker.openInfoWindow(_iw);
                            }
                        })()
                    }
                }
                //创建InfoWindow
                function createInfoWindow(i){
                    var json = markerArr[i];
                    var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>"+json.content+"</div>");
                    return iw;
                }
                //创建一个Icon
                function createIcon(json){
                    var icon = new BMap.Icon("../../static/img/address_small.png", new BMap.Size(json.w,json.h),{imageOffset: new BMap.Size(-json.l,-json.t),infoWindowOffset:new BMap.Size(json.lb+5,1),offset:new BMap.Size(json.x,json.h)})
                    return icon;
                }
                
                initMap();//创建和初始化地图
        },
        getBannerList () {
            this.$http({
                url: this.$http.adornUrl('/web/banner/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                    'type':4,
                    'productId':'',
                    'client':''
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = []
                    data.page.list.forEach( item => {
                        if(item.client == 1){
                            if(this.languageType == 0 && item.picUrl){
                                arr.push(item)
                            }else if(this.languageType == 1 && item.enPicUrl){
                                 arr.push(item)
                            }
                        }
                    })
                    this.bannerList = arr
                } else {
                    this.bannerList = []
                }
            })
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}}),
            this.$emit('changeIndex',5)
        }
    }
}
</script>

<style lang="less" scoped>
    .contact {
        max-width: 1920px;
        .banner {
            height: 330px;
            img {
                height: 330px;
                cursor: pointer;
            }
        }
        .head_title {
            width: 1170px;
            margin: 0 auto;
            overflow: hidden;
            height: 76px;
            ul {
                margin-top: 20px;
                float: left;
                li {
                        width: 110px;
                        padding: 0 40px;
                        cursor: pointer;
                        border-left: 1px solid #b2b2b2;
                        border-right: 1px solid #b2b2b2;
                        position: relative;
                        p {
                            color: #e21711;
                            font-size: 20px;
                        }
                        span {
                            color: #e21711;
                            font-size: 14px;
                        }

                    }
            }
            .local {
                float: right;
                p {
                    color: #606060;
                    font-size: 16px;
                    margin: 31px 0;
                }
            }
        }
        .content {
            position: relative;
            background-color: #f4f4f4;
            overflow: hidden;
            .intro {
                width: 1170px;
                background-color: #fff;
                margin: 0 auto;
                padding-bottom: 90px;
                margin-bottom: 90px;
                position: relative;
                z-index: 999;
                .top {
                    margin: 30px 80px 90px 80px;
                    overflow: hidden;
                    .text {
                        float: left;
                        margin-top: 30px;
                        .title {
                            text-align: left;
                            p {
                                font-size: 30px;
                                color: #606060;
                                margin-top: 0;
                                font-weight: 700;
                            }
                            span {
                                font-size: 18px;
                                color: #ababab;
                            }
                        }
                        p {
                            font-size: 18px;
                            color: #000000;
                            margin-top: 50px;
                            text-align: left;
                        }
                    }
                    .ewm {
                        float: right;
                        width: 120px;
                        img {
                            width: 120px;
                            height: 120px;
                            margin:120px 0 20px 0;
                        }
                        p {
                            font-size: 18px;
                            color: #000000;
                            font-weight: 700;
                            text-align: center;
                        }
                    }
                }
                .bottom {
                    .map {
                        width: 1010px;
                        height: 330px;
                        margin: 0 80px 0px 80px;
                    }
                }
                
            }
        }
        .content::before {
            content: '';
            display: block;
            position: absolute;
            top: -180px;
            left: -440px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/long.png)no-repeat center center;
            transform: scale(0.8)
        }
        .content::after {
            content: '';
            display: block;
            position: absolute;
            right: -275px;
            bottom: -160px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/tu.png)no-repeat center center;
            transform: scale(0.8)
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/contact.vue